import React from 'react';
import { Slider, SliderMarkerLabels } from '../../../../components';

import { Rating, updateRating } from './Rating';
import {
    Card,
    CardType,
    LabelBodySmall,
    LabelHeader5,
    Spacer,
} from '../../components';

type RatingCardProps = {
    rating: Rating;
    ratings: Rating[];
    onChangeRatings: (ratings: Rating[]) => void;
    minText: string;
    maxText: string;
    disabled?: boolean;
};

export function RatingSlider({
    rating,
    ratings,
    onChangeRatings,
    minText,
    maxText,
    disabled = false,
}: RatingCardProps) {
    return (
        <Card type={disabled ? CardType.Grey : CardType.Red}>
            <LabelHeader5
                className="mb-20"
                color={
                    disabled
                        ? 'text-grey-textfield-placeholder'
                        : 'text-dark-red'
                }
            >
                {rating.name}
            </LabelHeader5>
            <SliderMarkerLabels disabled={disabled} min={1} max={5} />
            <Slider
                min={1}
                max={5}
                value={rating.rating}
                onChangeValue={(newRating) =>
                    onChangeRatings(updateRating(ratings, rating, newRating))
                }
                disabled={disabled}
            />
            <div className="mt-20 flex">
                <LabelBodySmall
                    color={
                        disabled
                            ? 'text-grey-textfield-placeholder'
                            : 'text-grey-900'
                    }
                >
                    {minText}
                </LabelBodySmall>
                <Spacer className="ml-10" />
                <LabelBodySmall
                    color={
                        disabled
                            ? 'text-grey-textfield-placeholder'
                            : 'text-grey-900'
                    }
                >
                    {maxText}
                </LabelBodySmall>
            </div>
        </Card>
    );
}
